import { render } from "./FavPanel.vue?vue&type=template&id=427fb138&scoped=true"
import script from "./FavPanel.vue?vue&type=script&lang=js"
export * from "./FavPanel.vue?vue&type=script&lang=js"

import "./FavPanel.vue?vue&type=style&index=0&id=427fb138&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427fb138"]])

export default __exports__